import React, { useEffect, useState } from 'react';
import { IntegrationGooglePickerButton } from './google-picker-button';
import { Token, useApiIntegrations } from 'src/common/api/use-integrations.hook';
import classNames from 'classnames';
import { IntegrationConnectButton } from './connect-button';
import { NeueLoadingSpinner } from '../components/loading/spinner';

type Props = {
  onNewUrl: (url: string, title: string) => void;
};

export const IntegrationGoogleDrivePanel = ({ onNewUrl }: Props) => {


  const [loaded, setLoaded] = useState(false);
  const { fetchAccessTokens } = useApiIntegrations();

  const [tokens, setTokens] = useState<Token[]>([]);

  const loadTokens = () => {
    fetchAccessTokens('google-drive')
      .then((tokens: Token[]) => {
        setTokens(tokens);
        setLoaded(true);
      })
      .catch((err) => {
        setLoaded(false);
      });
  };

  useEffect(() => {
    loadTokens();
  }, []);

  const onGoogleDriveFileSelected = (embedUrl: string, title: string) => {
    onNewUrl(embedUrl, title);
  };

  if (loaded && tokens.length === 0) {
    return (
      <div className='flex flex-col space-y-4 text-neue-journey-fg'>
        <div className='text-neue-journey-small'>
          Connect Google Drive account to quickly import content into Journey
        </div>
        <IntegrationConnectButton onIntegrationConnected={loadTokens} provider={'google-drive'} />
      </div>
    );
  }

  return (
    <div
      className={classNames('flex flex-col space-y-4 h-full w-full overflow-y-auto', {
        'justify-center items-center': !loaded,
      })}
    >
      {tokens.map((token: Token) => (
        <div className='flex flex-col space-y-4'>
          <div className='text-neue-journey-small'>Connected to: {token.email}</div>
          <IntegrationGooglePickerButton token={token} onFileSelected={onGoogleDriveFileSelected} />
        </div>
      ))}
      {!loaded && <NeueLoadingSpinner theme='journey' size='16' className='h-full' />}
    </div>
  );
};
